module.exports = __webpack_public_path__ + "img/cart-delete-bg.bae0ff75.png";